import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useUserStore } from "@/common/store";
import { isPageAllowed } from "@/common/utils/geoRules";
import { useScrollStore } from "@/common/store/scrollStore";
import { popupBus } from "@/common/buses";
import { PopupsEnum } from "@/components/popup-dispatcher/PopupDispatcher/popups";

export const useCensor = () => {
  const [censorOff, setCensorOff] = useState<boolean>(false);
  const { pathname } = useLocation();

  const location = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);
  const appElement = useScrollStore((state) => state.scrollElement);

  useEffect(() => {
    appElement?.classList.add("censored");

    if (isPageAllowed(pathname, location) || currentUser?.verified || censorOff) {
      appElement?.classList.remove("censored");
    }
  }, [appElement, pathname, currentUser, location, censorOff]);

  useEffect(() => {
    popupBus.on("opened", (event) => {
      if (event.name === PopupsEnum.Verification) {
        setCensorOff(true);
      }
    });
  }, []);
};
